(function ($) {
    $.fn.videoLink = function () {
        return this.each(() => {
            //const $self = $(this);
            //let slideCount = $self.find('.thumbnail-slider.splide .splide__slide').length;

            $('.play-btn').on('click', function(e) {
              $(this).hide();
              $(this).next('.youtube-title').hide();
              $(this).prev('iframe').show();
              $(this).prev('iframe')[0].src +='?autoplay=1';
              e.preventDefault();
            });           


        });
        
    }

    $(() => {
        $('.wysiwyg-module .video-block').videoLink();
    })

})($);


// WEBPACK FOOTER //
// ./scripts/modules/video-link-shortcode.js